import React from 'react';
// outline (default) icons + solid icons
import AlertCircle from '../../@assets/icons/alert-circle.svg?react';
import AlertTriangle from '../../@assets/icons/alert-triangle.svg?react';
import ArrowClockwiseSolid from '../../@assets/icons/arrow-clockwise-solid.svg?react';
import ArrowDownCircle from '../../@assets/icons/arrow-down-circle.svg?react';
import ArrowDown from '../../@assets/icons/arrow-down.svg?react';
import ArrowFatLIneRightSolid from '../../@assets/icons/arrow-fat-line-right-solid.svg?react';
import ArrowLeftCircle from '../../@assets/icons/arrow-left-circle.svg?react';
import ArrowLeft from '../../@assets/icons/arrow-left.svg?react';
import ArrowRightCircle from '../../@assets/icons/arrow-right-circle.svg?react';
import ArrowUUpLeftSolid from '../../@assets/icons/arrow-u-up-left-solid.svg?react';
import ArrowRight from '../../@assets/icons/arrow-right.svg?react';
import ArrowUpCircle from '../../@assets/icons/arrow-up-circle.svg?react';
import ArrowUp from '../../@assets/icons/arrow-up.svg?react';
import BadgeCheckSolid from '../../@assets/icons/badge-check-solid.svg?react';
import BarricadeSolid from '../../@assets/icons/barricade-solid.svg?react';
import Briefcase from '../../@assets/icons/briefcase.svg?react';
import Buoy from '../../@assets/icons/buoy.svg?react';
import CalendarDotsSolid from '../../@assets/icons/calendar-dots-solid.svg?react';
import CaretDown from '../../@assets/icons/caret-down.svg?react';
import CaretUp from '../../@assets/icons/caret-up.svg?react';
import ChatCircleTextSolid from '../../@assets/icons/chat-circle-text-solid.svg?react';
import CheckCircleSolid from '../../@assets/icons/check-circle-solid.svg?react';
import CheckCircle from '../../@assets/icons/check-circle.svg?react';
import CheckDouble from '../../@assets/icons/check-double.svg?react';
import CheckFatSolid from '../../@assets/icons/check-fat-solid.svg?react';
import Check from '../../@assets/icons/check.svg?react';
import ChevronDown from '../../@assets/icons/chevron-down.svg?react';
import ChevronLeft from '../../@assets/icons/chevron-left.svg?react';
import ChevronRight from '../../@assets/icons/chevron-right.svg?react';
import ChevronUp from '../../@assets/icons/chevron-up.svg?react';
import ClockSolid from '../../@assets/icons/clock-solid.svg?react';
import CloverSolid from '../../@assets/icons/clover-solid.svg?react';
import CreditCardSolid from '../../@assets/icons/credit-card-solid.svg?react';
import DownloadSimpleSolid from '../../@assets/icons/download-simple-solid.svg?react';
import Earth from '../../@assets/icons/earth.svg?react';
import Edit from '../../@assets/icons/edit.svg?react';
import EnvelopeSolid from '../../@assets/icons/envelope-solid.svg?react';
import ExclamationCircleSolid from '../../@assets/icons/exclamation-circle-solid.svg?react';
import ExternalLink from '../../@assets/icons/external-link.svg?react';
import FilePdfSolid from '../../@assets/icons/file-pdf-solid.svg?react';
import FilesSolid from '../../@assets/icons/files-solid.svg?react';
import GlobeSolid from '../../@assets/icons/globe-solid.svg?react';
import HandCoinSolid from '../../@assets/icons/hand-coin-solid.svg?react';
import HandWavingSolid from '../../@assets/icons/hand-waving-solid.svg?react';
import HelpCircle from '../../@assets/icons/help-circle.svg?react';
import HighCostWarningSolid from '../../@assets/icons/high-cost-warning-solid.svg?react';
import InfoSolid from '../../@assets/icons/info-solid.svg?react';
import Info from '../../@assets/icons/info.svg?react';
import LifeBuoySolid from '../../@assets/icons/life-buoy-solid.svg?react';
import Mail from '../../@assets/icons/mail.svg?react';
import MapPin from '../../@assets/icons/map-pin.svg?react';
import MenuLeftSolid from '../../@assets/icons/menu-left-solid.svg?react';
import MenuRightSolid from '../../@assets/icons/menu-right-solid.svg?react';
import MenuSolid from '../../@assets/icons/menu-solid.svg?react';
import Menu from '../../@assets/icons/menu.svg?react';
import Minus from '../../@assets/icons/minus.svg?react';
import MinusCircle from '../../@assets/icons/minus-circle.svg?react';
import MoneyMultiple from '../../@assets/icons/money-multiple.svg?react';
import MoneySolid from '../../@assets/icons/money-solid.svg?react';
import MoneyWaveySolid from '../../@assets/icons/money-wavey-solid.svg?react';
import PencilCircleSolid from '../../@assets/icons/pencil-circle-solid.svg?react';
import PencilRulerSolid from '../../@assets/icons/pencil-ruler-solid.svg?react';
import PencilSimpleLine from '../../@assets/icons/pencil-simple-line.svg?react';
import PhoneRingSolid from '../../@assets/icons/phone-ring-solid.svg?react';
import Phone from '../../@assets/icons/phone.svg?react';
import PiggyBankSolid from '../../@assets/icons/piggy-bank-solid.svg?react';
import Plus from '../../@assets/icons/plus.svg?react';
import PlusSolid from '../../@assets/icons/plus-solid.svg?react';
import PlusCircle from '../../@assets/icons/plus-circle.svg?react';
import PlusSquareSolid from '../../@assets/icons/plus-square-solid.svg?react';
import PlusSquare from '../../@assets/icons/plus-square.svg?react';
import PuzzleSolid from '../../@assets/icons/puzzle-solid.svg?react';
import ReceiptRefund from '../../@assets/icons/receipt-refund.svg?react';
import SealCheckSolid from '../../@assets/icons/seal-check-solid.svg?react';
import ShieldSolid from '../../@assets/icons/shield-solid.svg?react';
import Shield from '../../@assets/icons/shield.svg?react';
import TableSolid from '../../@assets/icons/table-solid.svg?react';
import ThumbsUpSolid from '../../@assets/icons/thumbs-up-solid.svg?react';
import Trash from '../../@assets/icons/trash.svg?react';
import UploadSolid from '../../@assets/icons/upload-solid.svg?react';
import UserSolid from '../../@assets/icons/user-solid.svg?react';
import User from '../../@assets/icons/user.svg?react';
import UsersThree from '../../@assets/icons/users-three.svg?react';
import WarningSolid from '../../@assets/icons/warning-solid.svg?react';
import XCircleSolid from '../../@assets/icons/x-circle-solid.svg?react';
import XCircle from '../../@assets/icons/x-circle.svg?react';
import XSolid from '../../@assets/icons/x-solid.svg?react';
import X from '../../@assets/icons/x.svg?react';
import FacebookSolid from '../../@assets/icons/facebook-solid.svg?react';
import InstagramSolid from '../../@assets/icons/instagram-solid.svg?react';
import LinkedInSolid from '../../@assets/icons/linkedin-solid.svg?react';
import ClockOutlineSolid from '../../@assets/icons/clock-outline-solid.svg?react';

// new icon set
import PhoneOutline16 from '../../@assets/icons/phone-outline-16.svg?react';

export const Icons = [
  'alert-circle',
  'alert-triangle',
  'arrow-clockwise-solid',
  'arrow-down',
  'arrow-down-circle',
  'arrow-fat-line-right-solid',
  'arrow-left',
  'arrow-left-circle',
  'arrow-right',
  'arrow-right-circle',
  'arrow-u-up-left-solid',
  'arrow-up',
  'arrow-up-circle',
  'badge-check-solid',
  'barricade-solid',
  'briefcase',
  'buoy',
  'calendar-dots-solid',
  'caret-down',
  'caret-up',
  'chat-circle-text-solid',
  'check',
  'check-fat-solid',
  'check-double',
  'check-circle',
  'check-circle-solid',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'clock-solid',
  'clover-solid',
  'credit-card-solid',
  'download-simple-solid',
  'earth',
  'edit',
  'envelope-solid',
  'exclamation-circle-solid',
  'external-link',
  'file-pdf-solid',
  'files-solid',
  'globe-solid',
  'help-circle',
  'hand-coin-solid',
  'hand-waving-solid',
  'high-cost-warning-solid',
  'info',
  'info-solid',
  'life-buoy-solid',
  'mail',
  'map-pin',
  'menu',
  'menu-left-solid',
  'menu-right-solid',
  'menu-solid',
  'minus',
  'minus-circle',
  'money-solid',
  'money-multiple',
  'money-wavey-solid',
  'pencil-ruler-solid',
  'pencil-simple-line',
  'pencil-circle',
  'piggy-bank-solid',
  'phone',
  'phone-outline-16',
  'phone-ring-solid',
  'plus',
  'plus-solid',
  'plus-circle',
  'plus-square-solid',
  'plus-square',
  'puzzle-solid',
  'receipt-refund',
  'seal-check-solid',
  'shield',
  'shield-solid',
  'table-solid',
  'thumbs-up-solid',
  'trash',
  'upload-solid',
  'user',
  'user-solid',
  'users-three',
  'warning-solid',
  'x',
  'x-circle',
  'x-circle-solid',
  'x-solid',
  'facebook-solid',
  'instagram-solid',
  'linkedin-solid',
  'clock-outline-solid',
] as const;

export type IconName = (typeof Icons)[number];

export const IconComponents: Record<
  IconName,
  // React.FC<React.SVGAttributes<SVGElement>>
  React.FC<React.ComponentProps<'svg'>>
> = {
  'alert-circle': AlertCircle,
  'alert-triangle': AlertTriangle,
  'arrow-clockwise-solid': ArrowClockwiseSolid,
  'arrow-down': ArrowDown,
  'arrow-down-circle': ArrowDownCircle,
  'arrow-fat-line-right-solid': ArrowFatLIneRightSolid,
  'arrow-left': ArrowLeft,
  'arrow-left-circle': ArrowLeftCircle,
  'arrow-right': ArrowRight,
  'arrow-right-circle': ArrowRightCircle,
  'arrow-u-up-left-solid': ArrowUUpLeftSolid,
  'arrow-up': ArrowUp,
  'arrow-up-circle': ArrowUpCircle,
  'badge-check-solid': BadgeCheckSolid,
  'barricade-solid': BarricadeSolid,
  briefcase: Briefcase,
  buoy: Buoy,
  'calendar-dots-solid': CalendarDotsSolid,
  'caret-down': CaretDown,
  'caret-up': CaretUp,
  'chat-circle-text-solid': ChatCircleTextSolid,
  check: Check,
  'check-fat-solid': CheckFatSolid,
  'check-double': CheckDouble,
  'check-circle': CheckCircle,
  'check-circle-solid': CheckCircleSolid,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'clock-solid': ClockSolid,
  'clover-solid': CloverSolid,
  'credit-card-solid': CreditCardSolid,
  'download-simple-solid': DownloadSimpleSolid,
  earth: Earth,
  edit: Edit,
  'envelope-solid': EnvelopeSolid,
  'exclamation-circle-solid': ExclamationCircleSolid,
  'external-link': ExternalLink,
  'file-pdf-solid': FilePdfSolid,
  'files-solid': FilesSolid,
  'globe-solid': GlobeSolid,
  'help-circle': HelpCircle,
  'hand-coin-solid': HandCoinSolid,
  'hand-waving-solid': HandWavingSolid,
  'high-cost-warning-solid': HighCostWarningSolid,
  info: Info,
  'info-solid': InfoSolid,
  'life-buoy-solid': LifeBuoySolid,
  mail: Mail,
  'map-pin': MapPin,
  menu: Menu,
  'menu-left-solid': MenuLeftSolid,
  'menu-right-solid': MenuRightSolid,
  'menu-solid': MenuSolid,
  minus: Minus,
  'minus-circle': MinusCircle,
  'money-solid': MoneySolid,
  'money-multiple': MoneyMultiple,
  'money-wavey-solid': MoneyWaveySolid,
  'pencil-ruler-solid': PencilRulerSolid,
  'pencil-simple-line': PencilSimpleLine,
  'pencil-circle': PencilCircleSolid,
  'piggy-bank-solid': PiggyBankSolid,
  phone: Phone,
  'phone-ring-solid': PhoneRingSolid,
  'phone-outline-16': PhoneOutline16,
  plus: Plus,
  'plus-solid': PlusSolid,
  'plus-circle': PlusCircle,
  'plus-square-solid': PlusSquareSolid,
  'plus-square': PlusSquare,
  'puzzle-solid': PuzzleSolid,
  'receipt-refund': ReceiptRefund,
  'seal-check-solid': SealCheckSolid,
  shield: Shield,
  'shield-solid': ShieldSolid,
  'table-solid': TableSolid,
  'thumbs-up-solid': ThumbsUpSolid,
  'upload-solid': UploadSolid,
  user: User,
  'user-solid': UserSolid,
  'users-three': UsersThree,
  trash: Trash,
  'warning-solid': WarningSolid,
  x: X,
  'x-circle': XCircle,
  'x-circle-solid': XCircleSolid,
  'x-solid': XSolid,
  'facebook-solid': FacebookSolid,
  'instagram-solid': InstagramSolid,
  'linkedin-solid': LinkedInSolid,
  'clock-outline-solid': ClockOutlineSolid,
};
